import React from "react"
import PropTypes from "prop-types"

import LexForm from './LexForm'
import AlertModal from '../app_components/AlertModal'
import StandardModal from '../app_components/StandardModal';
import moment from 'moment'
import { lexMoment } from '../utils/lexTime'

class ChangeLexForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      date: '',
      time: '',
      location: '',
      location_address: '',
      otherUser: [],
      currentUser: [],
      nativeLanguage: [],
      learningLanguage: [],
      learningLanguageChoices: [],
      nativeLanguageChoices: [],
      languagesLoaded: false,
      formError: '',
      submittingForm: false,
      scheduleSuccess: false,
      rescheduleSuccess: false,
      meeting: '',
    }

    this.setInitialLanguages = this.setInitialLanguages.bind(this)
    this.submitForm = this.submitForm.bind(this)
  }

  componentDidMount() {
    //get other user information
    //get current user languages
    $.ajax({
      url: `../getLexInfo`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
      },
      success: (data) => {
        const meeting = JSON.parse(data.data.meeting)
        this.setState({
          date: lexMoment(meeting.meeting_time).toDate(),
          time: lexMoment(meeting.meeting_time).format('LT'),
          location: meeting.location,
          location_address: meeting.location_address,
          otherUser: JSON.parse(data.data.otherUser),
          currentUser: JSON.parse(data.data.currentUser),
          meeting: meeting,
          learningLanguage: meeting.lang_two,
          nativeLanguage: meeting.lang_one
        }, () => this.setInitialLanguages())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  async setInitialLanguages() {
    const learningLanguageChoices = []
    const nativeLanguageChoices = []
    await this.state.currentUser.languages_users.map((language, i) => {
      if(language.level < 5) {
        //loop through otherUser langs where level === 5, if same ID add to arry
         this.state.otherUser.languages_users.map((lang, i) => {
          if(lang.language_id === language.language_id && lang.level === 5) {
            learningLanguageChoices.push(language.language)
            this.setState({
              learningLanguageChoices: learningLanguageChoices,
            })
          }
        })
      } else {
         this.state.otherUser.languages_users.map((lang, i) => {
          if(lang.language_id === language.language_id && lang.level < 5) {
            nativeLanguageChoices.push(language.language)
            this.setState({
              nativeLanguageChoices: nativeLanguageChoices,
            })
          }
        })
      }
    })
    await this.setState({languagesLoaded: true})
  }

  submitForm(data) {

    let newData = {
      ...data,
      meeting_id: this.state.meeting.id
    }

    this.setState({
      submittingForm: true
    })

    $.ajax({
      url: `../updateLexInfo`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: newData,
      success: (data) => {
        this.setState({
          meeting: JSON.parse(data.data.meeting),
          submittingForm: false,
          scheduleSuccess: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  render() {
    if (this.state.languagesLoaded && (this.state.learningLanguageChoices < 1 || this.state.nativeLanguageChoices < 1)){
      return(
        <StandardModal onClose={this.props.onClose} modalClass="standardModal--lexForm">
          <div className="lex-form__empty">
            <p className="lex-form__emptyText">
              You can not schedule a Lex because you do not have matching languages
            </p>
          </div>
        </StandardModal>
      )
    } else if (this.state.scheduleSuccess) {
      return(
        <AlertModal
          onClose={this.props.onClose}
          bannerText="Success!"
          headerText={`${this.state.otherUser.first_name} has until ${moment(this.state.meeting.meeting_time).subtract(1, 'days').calendar().split(" at")[0]} to accept`}
          subHeaderText="Next up: plan your Lex"
          mainText={`Planning activities ensures your Lex is a success. Lexody provides games and activities to play. Pro tip: download the app for a better experience!`}
          buttonText="Find activities for Lex"
          onClick={() => window.location.replace(`/meetings/${this.state.meeting.id}`)}
        />
      )
    } else if (this.state.languagesLoaded) {
      return(
        <LexForm
          onClose={this.props.onClose}
          otherUser={this.state.otherUser}
          currentUser={this.state.currentUser}
          learningLanguage={this.state.learningLanguage}
          learningLanguageChoices={this.state.learningLanguageChoices}
          nativeLanguage={this.state.nativeLanguage}
          nativeLanguageChoices={this.state.nativeLanguageChoices}
          date={this.state.date}
          time={this.state.time}
          location={this.state.location}
          location_address={this.state.location_address}
          submittingForm={this.state.submittingForm}
          submitForm={this.submitForm}
        />
      )
    }
    return null
  }

}

export default ChangeLexForm
